const STORAGE_KEY = "free_3_minutes_gift_shown"

/** True after the free-3-minutes gift modal has auto-shown once. */
export function hasShownFree3MinutesGift(): boolean {
  try {
    return window.localStorage.getItem(STORAGE_KEY) === "1"
  } catch {
    return false
  }
}

/** Persist that the free-3-minutes gift modal was auto-shown. */
export function markFree3MinutesGiftShown(): void {
  try {
    window.localStorage.setItem(STORAGE_KEY, "1")
  } catch {
    /* ignore */
  }
}
